// extracted by mini-css-extract-plugin
module.exports = {"sticky":"style_sticky__o9ih3"};